<template>
    <v-row>
        <v-col cols="12">
            <v-card class="table-card">
                <v-card-title class="table-card-title">
                    Andamento do processo
                    <v-spacer></v-spacer>
                    <v-btn color="primary" elevation="0" @click="openForm()">Incluir evento</v-btn>
                </v-card-title>
                <v-card-subtitle>
                    Os eventos aparecem em ordem de data na página do processo no site (pedido, deferimento, editais,
                    assembleias etc.).
                </v-card-subtitle>
                <v-card-text>
                    <v-data-table :headers="headers" :items="items" :loading="loading" :disable-sort="true"
                        hide-default-footer :items-per-page="-1" no-data-text="Nenhum evento cadastrado"
                        loading-text="Carregando dados..." class="app-table hover-table">
                        <template v-slot:[`item.event_date`]="{ item }">
                            {{ item.event_date | defaultDate("DD/MM/YYYY") }}
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                            <span class="timeline-description">{{ item.description }}</span>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-row align="center" no-gutters>
                                <v-icon @click="openForm(item)" size="large" class="me-2">mdi-pencil-outline</v-icon>
                                <v-icon @click="deleteItem(item)" size="large">mdi-delete</v-icon>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>

        <v-dialog v-model="form.show" max-width="600" persistent>
            <v-card>
                <v-card-title>{{ form.data.id ? 'Editar evento' : 'Incluir evento' }}</v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-menu v-model="form.menuDate" :close-on-content-click="false" transition="scale-transition"
                            offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined readonly label="Data" v-bind="attrs" v-on="on"
                                    :value="form.data.event_date | defaultDate('DD/MM/YYYY')" :rules="[$rules.required]"
                                    hide-details="auto" class="mb-4"></v-text-field>
                            </template>
                            <v-date-picker v-model="form.data.event_date" no-title locale="pt-br"
                                @input="form.menuDate = false"></v-date-picker>
                        </v-menu>
                        <v-text-field dense outlined label="Evento" v-model="form.data.title" counter="255"
                            placeholder="Ex.: Deferimento do processamento da recuperação judicial"
                            :rules="[$rules.required]" hide-details="auto" class="mb-4"></v-text-field>
                        <v-textarea dense outlined label="Descrição (opcional)" v-model="form.data.description" rows="3"
                            auto-grow counter="2000" hide-details="auto"></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="form.show = false" :disabled="form.saving">Cancelar</v-btn>
                    <v-btn color="primary" elevation="0" @click="save" :loading="form.saving">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import axios from "axios";

export default {
    name: "ClientTimeline",

    props: {
        clientId: { type: [String, Number], required: true },
    },

    data: () => ({
        loading: false,
        items: [],
        headers: [
            { text: "Data", value: "event_date", width: 120 },
            { text: "Evento", value: "title" },
            { text: "Descrição", value: "description" },
            { text: "Ações", value: "actions", sortable: false, width: 100 },
        ],
        form: {
            show: false,
            saving: false,
            menuDate: false,
            data: {},
        },
    }),

    created() {
        this.load();
    },

    methods: {
        async load() {
            this.loading = true;
            try {
                const result = await axios.get(`/api/admin/clients/${this.clientId}/timeline`);
                this.items = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },

        openForm(item) {
            this.form.data = item
                ? { ...item, event_date: String(item.event_date).slice(0, 10) }
                : { event_date: null, title: "", description: "" };
            this.form.show = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            const payload = {
                event_date: this.form.data.event_date,
                title: this.form.data.title,
                description: this.form.data.description,
            };

            this.form.saving = true;
            try {
                if (this.form.data.id) await axios.patch(`/api/admin/timeline-events/${this.form.data.id}`, payload);
                else await axios.post(`/api/admin/clients/${this.clientId}/timeline`, payload);

                this.$dialog.notify.info("Evento salvo", { position: "top-right", timeout: 2000 });
                this.form.show = false;
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.form.saving = false;
            }
        },

        async deleteItem(item) {
            const proceedAction = await this.$dialog.confirm({
                text: `Excluir o evento "${item.title}"?`,
                title: "Excluir evento",
                actions: { false: "Cancelar", true: "Excluir" },
            });

            if (!proceedAction) return;

            try {
                await axios.delete(`/api/admin/timeline-events/${item.id}`);
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            }
        },
    },
};
</script>

<style scoped>
.timeline-description {
    white-space: pre-line;
}
</style>
